module.exports = __webpack_public_path__ + "1053ca45271eb2232e1f93e00f22fa23.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_r_70.mp3
// module id = 432
// module chunks = 0